import { Container, Graphics, Text } from "pixi.js";
import type { ContrabandBeacon } from "@frontier/protocol/contracts";
export function visibleBeacons(
  beacons: readonly ContrabandBeacon[],
  time: number,
): ContrabandBeacon[] {
  return beacons.filter((beacon) => beacon.expiresAt > time);
}
export class BeaconViews {
  readonly container = new Container();
  private readonly circles = new Graphics();
  private readonly labels = new Map<string, Text>();
  private beacons: readonly ContrabandBeacon[] = [];
  private receivedAt = 0;
  private time = 0;
  constructor() {
    this.container.addChild(this.circles);
  }
  receive(
    beacons: readonly ContrabandBeacon[],
    time: number,
    now: number,
  ): void {
    this.beacons = beacons;
    this.time = time;
    this.receivedAt = now;
  }
  render(now: number): void {
    const visible = visibleBeacons(
      this.beacons,
      this.time + (now - this.receivedAt) / 1000,
    );
    const ids = new Set(visible.map((beacon) => beacon.id));
    for (const [id, label] of this.labels)
      if (!ids.has(id)) {
        label.destroy();
        this.labels.delete(id);
      }
    this.circles.clear();
    for (const beacon of visible) {
      const alpha = 0.25 + Math.sin(now / 300) * 0.08;
      this.circles
        .circle(beacon.x, beacon.y, beacon.radius)
        .fill({ color: 0xdd8ce3, alpha: 0.035 })
        .stroke({ color: 0xe99ee9, width: 2, alpha });
      this.circles
        .circle(
          beacon.x,
          beacon.y,
          beacon.radius * (0.85 + Math.sin(now / 700) * 0.05),
        )
        .stroke({ color: 0xe99ee9, width: 1, alpha: 0.15 });
      let label = this.labels.get(beacon.id);
      if (!label) {
        label = new Text({
          text: "ПРИМЕРНЫЙ РАЙОН СИГНАЛА",
          style: { fontSize: 12, fill: 0xd8a4de, letterSpacing: 1 },
        });
        label.anchor.set(0.5);
        this.labels.set(beacon.id, label);
        this.container.addChild(label);
      }
      label.position.set(beacon.x, beacon.y - beacon.radius + 22);
    }
  }
}
